import { listenDb, offListenDb } from "@/js/firebase";
import { getUrlParam } from "@/js/functions";
import { useLiveStore } from "@/template/live/_store";
import React, { useEffect, useState } from "react";

const useSession = () => {
  const [activeSessionId, setactiveSessionId] = useState(["", ""]);
  const [sessionStatus, setsessionStatus] = useState(); // 0:停止 1:放送中 2:リハ
  const [activeSessionObj, setactiveSessionObj] = useState();
  const { setactiveSession } = useLiveStore();

  React.useEffect(() => {
    listenDb(`${getUrlParam(0)}/activeSession/${getUrlParam(1)}`, (v) => {
      if (v === null) return;
      setsessionStatus(v.status);
      setactiveSessionId((prev) => [prev[1], v.id]);
      setactiveSessionObj(v);
      setactiveSession(v);
    });

    return () => {
      offListenDb(`${getUrlParam(0)}/activeSession/${getUrlParam(1)}`);
    };
  }, []);

  return {
    activeSessionId,
    sessionStatus,
    activeSessionObj,
  };
};

export default useSession;
